import { AlertCircle, RefreshCw, Search } from "react-feather";
import Aviso from "./Aviso";
import BuscaGrande from "./BuscaGrande";

export type TipoDeErro = "nao_encontrado" | "invalido" | "falha";

// Enquanto busca: o desenho da página (status, histórico e vitrine) em cinza
// pulsando, no lugar de um giro solto no meio da tela.
export function Carregando() {
  const bloco = "animate-pulse rounded-lg bg-[#EFE6DD]";
  return (
    <div className="grid items-start gap-5 lg:grid-cols-[minmax(0,1fr)_360px] lg:gap-8" aria-busy="true" aria-label="Buscando o rastreio">
      <div className="min-w-0 space-y-5">
        <div className="-mx-4 -mt-6 bg-white px-5 py-7 sm:mx-0 sm:mt-0 sm:rounded-3xl sm:px-8">
          <div className={`${bloco} h-8 w-2/3`} />
          <div className={`${bloco} mt-3 h-4 w-1/2`} />
          <div className="mt-8 grid grid-cols-4 gap-3">
            {[0, 1, 2, 3].map((i) => (
              <div key={i} className={`${bloco} h-3`} />
            ))}
          </div>
        </div>
        <div className="space-y-4 rounded-3xl bg-white px-5 py-7 sm:px-8">
          {[0, 1, 2].map((i) => (
            <div key={i} className="flex gap-4">
              <div className={`${bloco} h-4 w-12`} />
              <div className={`${bloco} h-4 flex-1`} />
            </div>
          ))}
        </div>
      </div>
      <div className={`${bloco} hidden h-[520px] rounded-3xl lg:block`} />
    </div>
  );
}

// O que deu errado na busca, em linguagem de quem recebe a encomenda, e o
// caminho de volta (buscar de novo ou tentar outra vez).
export function ErroDoRastreio({
  tipo,
  codigo,
  onBuscar,
  onTentarDeNovo,
}: {
  tipo: TipoDeErro;
  codigo?: string;
  onBuscar: (codigo: string) => void;
  onTentarDeNovo: () => void;
}) {
  if (tipo === "falha") {
    return (
      <Aviso
        icone={<RefreshCw size={28} />}
        titulo="Não conseguimos consultar agora"
        texto="O serviço de rastreio não respondeu. Costuma ser rápido: tente de novo em alguns instantes."
      >
        <button
          type="button"
          onClick={onTentarDeNovo}
          className="inline-flex h-12 items-center gap-2 rounded-xl bg-[#3F2021] px-6 font-bold text-white transition hover:bg-[#2c1617]"
        >
          <RefreshCw size={16} />
          Tentar de novo
        </button>
        <a href="/" className="text-sm font-semibold text-[#C2410C] hover:underline">
          Voltar ao início
        </a>
      </Aviso>
    );
  }

  if (tipo === "invalido") {
    return (
      <Aviso
        icone={<AlertCircle size={28} />}
        titulo="Esse código não parece um código de rastreio"
        texto={
          <>
            {codigo && <strong className="font-mono text-[#3F2021]">{codigo}</strong>} Confira se o código foi copiado inteiro, sem espaços ou
            letras a mais.
          </>
        }
        dicas={["O código dos Correios tem 13 caracteres, como AA123456789BR.", "Copie e cole direto do e-mail ou da mensagem que você recebeu."]}
      >
        <BuscaGrande onBuscar={onBuscar} valor={codigo} />
      </Aviso>
    );
  }

  return (
    <Aviso
      icone={<Search size={28} />}
      titulo="Não encontramos esse código"
      texto={
        <>
          {codigo && <strong className="font-mono text-[#3F2021]">{codigo}</strong>} ainda não tem movimentação ou foi digitado com algum
          caractere trocado.
        </>
      }
      dicas={[
        "Envio recém-postado pode levar algumas horas para aparecer no rastreio.",
        "Confira letras e números: O (letra) e 0 (zero) se confundem fácil.",
        "Copie e cole o código direto do e-mail ou da mensagem que você recebeu.",
      ]}
    >
      <BuscaGrande onBuscar={onBuscar} valor={codigo} />
    </Aviso>
  );
}
